import { Node, mergeAttributes } from '@tiptap/core';
import { ETiptapAlignmentSelectorKey } from '../../../types/tiptap.types';
import { createParagraphBelowRowOnEnter } from './utils/rowEnter';
import { ELEMENT_ROW_NODE_NAME } from './constants';

const ElementRow = Node.create({
  name: ELEMENT_ROW_NODE_NAME,
  // Top-level block container (can appear where blocks can appear).
  group: 'block fieldBlock',
  // Accept any blocks inside the row (not just images).
  content: 'block*',
  // Treat as a meaningful, stable unit; but allow transforms to cross it.
  defining: true,
  // Prevent the empty paragraph from merging into it when Backspace is pressed.
  isolating: true,

  addAttributes() {
    return {
      /**
       * Logical alignment of the row. In the editor we interpret it as:
       *  - left   → justify-content: flex-start
       *  - center → justify-content: center
       *  - right  → justify-content: flex-end
       *
       * It’s stored as `data-align` for compatibility with existing CSS and
       * static export. The default is LEFT.
       */
      textAlign: {
        default: ETiptapAlignmentSelectorKey.LEFT,
        parseHTML: (el) => el.getAttribute('data-align') || ETiptapAlignmentSelectorKey.LEFT,
        renderHTML: (attrs) => ({ 'data-align': attrs.textAlign }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div.element-row-node' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { class: 'element-row-node' }), 0];
  },

  addKeyboardShortcuts() {
    return {
      // Intercept Enter anywhere inside the row (except on images)
      Enter: () => this.editor.commands.command(createParagraphBelowRowOnEnter),
    };
  },
});

export default ElementRow;
